import React, { useState } from 'react';
import AdventureSelector from './components/AdventureSelector';
import GameEngine from './components/GameEngine';

function App() {
  const [currentAdventure, setCurrentAdventure] = useState(null);
  const [gameMode, setGameMode] = useState('menu'); // 'menu' or 'playing'

  const handleSelectAdventure = (adventure) => {
    setCurrentAdventure(adventure);
    setGameMode('playing');
  };

  const handleReturnToMenu = () => {
    setGameMode('menu');
    setCurrentAdventure(null);
  };

  if (gameMode === 'playing' && currentAdventure) {
    return (
      <GameEngine 
        adventureData={currentAdventure} 
        onReturnToMenu={handleReturnToMenu} 
      />
    );
  }

  return (
    <AdventureSelector 
      onSelectAdventure={handleSelectAdventure}
      currentAdventure={currentAdventure}
    />
  );
}

export default App;